// Reading spreadsheets that admins upload (the unit and resident imports).

/**
 * Splits CSV text into rows of cells. Excel saves with semicolons in an
 * Indonesian locale and commas in an English one, so the separator is read
 * from the header line. Handles quoted cells and a byte-order mark.
 */
export function parseCsv(text: string): string[][] {
  // Excel puts a byte-order mark (U+FEFF) at the start of a UTF-8 CSV.
  const src = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text;
  const firstLine = src.split(/\r?\n/, 1)[0] ?? '';
  const sep = [';', ',', '\t'].reduce((best, s) => (firstLine.split(s).length > firstLine.split(best).length ? s : best), ';');

  const rows: string[][] = [];
  let row: string[] = [];
  let cell = '';
  let quoted = false;
  for (let i = 0; i < src.length; i++) {
    const ch = src[i]!;
    if (quoted) {
      if (ch === '"' && src[i + 1] === '"') {
        cell += '"';
        i++;
      } else if (ch === '"') {
        quoted = false;
      } else {
        cell += ch;
      }
    } else if (ch === '"') {
      quoted = true;
    } else if (ch === sep) {
      row.push(cell);
      cell = '';
    } else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && src[i + 1] === '\n') i++;
      row.push(cell);
      rows.push(row);
      row = [];
      cell = '';
    } else {
      cell += ch;
    }
  }
  if (cell !== '' || row.length > 0) {
    row.push(cell);
    rows.push(row);
  }
  return rows;
}

/** A header or a value compared loosely: "Blok / Jalan" and "blokjalan" match. */
export function headerKey(s: string): string {
  return s.trim().toLowerCase().replace(/[\s/_-]/g, '');
}
